export default __webpack_public_path__ + "static/media/13.d643fd21.png";